<script lang="ts" setup>
import BaseCardHeading from "@/components/BaseCardHeading.vue";
import { Heading } from "@/types/base-card";

const props = defineProps<{
  closable?: boolean;
  collapsible?: boolean;
  heading?: Heading;
  hasPageHeading?: boolean;
}>();

const collapsed = defineModel("collapsed");

const collapse = () => {
  if (!props.collapsible) {
    return;
  }

  collapsed.value = !collapsed.value;
};

const emit = defineEmits(["close"]);

function close(): void {
  emit("close");
}
</script>

<template>
  <header
    :class="{ 'hover:cursor-pointer': collapsible }"
    class="inline-flex w-full flex-row flex-wrap items-center justify-between bg-black/50 p-4 text-xl font-extrabold text-green-50 shadow-inner"
    @click="collapse"
  >
    <div class="flex gap-2">
      <template v-if="$slots.icon">
        <slot name="icon" />
      </template>
      <i-fa6-solid-square
        v-else
        class="-mr-1 mt-[5.5px] h-5 shrink-0 self-start text-green-300"
      />

      <BaseCardHeading
        :class="heading?.class"
        :is-page-heading="hasPageHeading"
      >
        <template v-if="$slots.subheading">
          <slot name="subheading" />
        </template>

        <slot />
      </BaseCardHeading>
    </div>

    <div
      class="inline-flex flex-1 items-center justify-end gap-2 whitespace-nowrap font-medium"
    >
      <slot name="actions" />

      <i-fa6-solid-xmark
        v-if="closable"
        class="shrink-0 hover:cursor-pointer"
        @click="close"
      />

      <i-fa6-solid-chevron-right
        v-else-if="collapsible"
        :class="[collapsed ? 'rotate-0' : 'rotate-90']"
        class="shrink-0 transition-transform"
      />
    </div>
  </header>
</template>
